import menus from '../secrets-web/src/config/menus';

import {
  SecurityScanOutlined
} from '@ant-design/icons'


export default {
  ...menus,
  ADMIN_MENUS: [
    ...menus.ADMIN_MENUS.filter((m) => !['WORKSPACE_INTEGRATION', 'WORKSPACE_EMAIL_SETTING'].includes(m.key)),
    {
      key: 'ACCOUNT_SECURITY',
      parent: 'ACCOUNT',
      icon: <SecurityScanOutlined />,
      label: "security.title",
    },
  ]
}
